import React from 'react';
import useOpportunitySivaContract from '../../hooks/use-opportunity-siva-contract';
import { useParams } from 'react-router-dom';
import { PageParams } from '../../types/PageParams';
import { DateCell } from 'src/components/DataTableV3/components/formatters/Date';
import SivaPhaseTag from 'src/features/siva/ideas-and-companies/components/SivaPhaseTag';
import NumericIdLink from 'src/features/siva/ideas-and-companies/components/NumericIdLink';
import { SivaPhase } from 'src/api/v2';
import { useTranslation } from 'react-i18next';
import InfoBox from './InfoBox';

const SivaContractInfo = () => {
  const { formId } = useParams<PageParams>();
  const { data } = useOpportunitySivaContract(formId);
  const { t: tOneWayIn } = useTranslation('oneWayIn');

  const currentPhase = data?.requestedContract.phases
    .slice()
    .sort((a, b) => Number(b.fromDate) - Number(a.fromDate))[0]?.sivaPhase;
  // Contracts still in the Idea phase have no admission date yet; fall back to
  // the phase's registration date and label it accordingly instead of showing
  // a misleading "Admission date".
  const isIdea = currentPhase === SivaPhase.Idea;
  const admissionDate = isIdea
    ? data?.requestedContract.fromDate
    : (data?.requestedContract.admissionDate ?? data?.requestedContract.fromDate);
  const admissionDateLabel = isIdea
    ? tOneWayIn('opportunityDetails.RegisteredDate')
    : tOneWayIn('opportunityDetails.AdmissionDate');

  return (
    <InfoBox heading={tOneWayIn('opportunityDetails.Contract')}>
      <div className="opportunity-overview--siva-contract-container">
        <SivaContractInfoRow
          label="ID"
          value={data ? <NumericIdLink numericId={data.requestedContract.numericId} /> : undefined}
        />
        <SivaContractInfoRow
          label={tOneWayIn('opportunityDetails.Phase')}
          value={currentPhase ? <SivaPhaseTag phase={currentPhase} /> : undefined}
        />
        <SivaContractInfoRow
          label={admissionDateLabel}
          value={admissionDate ? <DateCell value={admissionDate} /> : undefined}
        />
        <SivaContractInfoRow
          label={tOneWayIn('opportunityDetails.Advisor')}
          value={data?.requestedContract.advisorName}
        />
      </div>
    </InfoBox>
  );
};

const SivaContractInfoRow = ({ label, value }: { label: string; value: React.ReactNode }) => {
  return (
    <>
      <strong>{label}</strong>
      <span className="text-align--left">{value}</span>
    </>
  );
};

export default SivaContractInfo;
